import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActiveSendMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z",
			fill: "url(#paint0_linear_38212_707)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_38212_707)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M22.1133 28.0716C22.145 28.1505 22.2 28.2179 22.271 28.2646C22.3421 28.3113 22.4257 28.3352 22.5107 28.333C22.5957 28.3308 22.678 28.3027 22.7465 28.2524C22.815 28.2021 22.8666 28.1321 22.8941 28.0516L28.3108 12.2183C28.3375 12.1445 28.3426 12.0646 28.3255 11.9879C28.3084 11.9113 28.2698 11.8411 28.2143 11.7856C28.1588 11.7301 28.0886 11.6915 28.012 11.6745C27.9354 11.6574 27.8555 11.6625 27.7816 11.6891L11.9483 17.1058C11.8679 17.1334 11.7978 17.1849 11.7475 17.2534C11.6972 17.322 11.6691 17.4043 11.6669 17.4893C11.6648 17.5743 11.6886 17.6579 11.7354 17.7289C11.7821 17.7999 11.8494 17.855 11.9283 17.8866L18.5366 20.5366C18.7456 20.6203 18.9354 20.7453 19.0946 20.9043C19.2539 21.0633 19.3793 21.2529 19.4633 21.4616L22.1133 28.0716Z",
				stroke: "white",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M28.2116 11.7892L19.095 20.905",
				stroke: "white",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_38212_707",
			x1: 20,
			y1: 0,
			x2: 20,
			y2: 40,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#7C3AED" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A855F7"
			})]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_38212_707",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white",
				transform: "translate(10 10)"
			})
		})] })
	]
});
export default SvgActiveSendMessage;
